import { Availability } from 'types';

export enum AvailabilityStatus {
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable',
  UNAVAILABLE_TODAY = 'unavailable-today',
  MIXED = 'mixed'
}

export const UNCATEGORISED_CATEGORY_MMID = 'UNCATEGORISED';

export const availabilities: Availability[] = [
  {
    id: '1',
    name: 'Available',
    slug: 'available'
  },
  {
    id: '2',
    name: 'Unavailable today',
    slug: 'unavailable-today'
  },
  {
    id: '3',
    name: 'Unavailable',
    slug: 'unavailable'
  },
  {
    id: '4',
    name: 'Mixed',
    slug: 'mixed'
  }
];
